function _of(x) {
  return [x];
}
module.exports = _of;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_of.js
// module id = 335
// module chunks = 33587185282056 114276838955818